<template>
  <div class="j-grid">
    <div class="j-item">
      <span>{{ $t('Webportal.CX.BMW.Journey.Text1BecomeAware') }}</span>
    </div>
    <div class="j-icon">
      <font-awesome-icon :icon="['fas', 'heart']" />
    </div>
    <div class="j-chevron" />

    <div class="j-item">
      <span>{{ $t('Webportal.CX.BMW.Journey.Text2Identify') }}</span>
    </div>
    <div class="j-icon">
      <font-awesome-icon :icon="['fas', 'search']" />
    </div>
    <div class="j-chevron" />

    <div class="j-item">
      <span>{{ $t('Webportal.CX.BMW.Journey.Text3Get') }}</span>
    </div>
    <div class="j-icon">
      <font-awesome-icon :icon="['fas', 'diamond']" />
    </div>
    <div class="j-chevron" />

    <div class="j-item">
      <span>{{ $t('Webportal.CX.BMW.Journey.Text4Enjoy', { brand: brand }) }}</span>
    </div>
    <div class="j-icon j-icon-last">
      <font-awesome-icon :icon="['fas', 'globe-africa']" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    brand: { type: String, default: 'BMW/MINI' },
    isSmall: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
@use "@/../scss/bmw/cx.scss";

@media (min-width: 1280px)  {
 .j-grid {
    display: grid;
    grid-template-columns: 5fr 1fr 1fr 5fr 1fr 1fr 2fr 1fr 1fr 2fr 1fr;
    grid-gap: 0;
    justify-content: stretch;
    min-height: 100px;
    max-height: 100px;
    background: cx.$bg-color;
    padding-left: 1rem;
  }
  .j-item {
    font-size: 1.1em;
    font-weight: 600;
    color: cx.$fg-color;
    margin: auto;
  }
}

@media (max-width: 1279px)  {
  .j-grid {
    display: grid;
    grid-template-columns: 5fr 1fr 1fr 5fr 1fr 1fr 2fr 1fr 1fr 2fr 1fr;
    grid-gap: 0;
    justify-content: stretch;
    min-height: 100px;
    max-height: 100px;
    background:  cx.$bg-color;
    padding-left: 1rem;
  }
  .j-item {
    font-size: 0.8em;
    font-weight: 600;
    color: cx.$fg-color;
    margin: auto;
  }
}

.j-icon {
  font-size: 2.5rem;
  color: cx.$light-icon-color;
  margin: auto;
  margin-right: -24px !important;
}

.j-icon-last {
  margin-right: 12px !important;
}

.j-chevron {
  transform: rotate(-90deg);
  position: relative;
  padding: 0px;
  margin-bottom: 0px;
  height: 8px;
  width: 100px;
  top: 46px;
}

.j-chevron:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 51%;
  background: cx.$light-icon-color;
  transform: skew(0deg, 22deg);
}

.j-chevron:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  background: cx.$light-icon-color;
  transform: skew(0deg, -22deg);
}

</style>
